import trim from 'lodash/trim';
import isEmpty from 'validator/lib/isEmpty';
import isURL from 'validator/lib/isURL';

import { isLongFormProject } from 'src/data/project';
import { validate } from 'src/lib/validation';

import { CONTENT_TYPE } from './contentType';

const emptyUrlMessage = (projectType, contentType) => {
  if (isLongFormProject(projectType)) {
    return 'Please enter a URL.';
  }

  return contentType === CONTENT_TYPE.content
    ? 'Please enter a URL of an article or blog post.'
    : 'Please enter a URL. It should have some info about your product/service.';
};

const invalidUrlMessage = (projectType, contentType) => {
  if (isLongFormProject(projectType)) {
    return 'Please enter a valid URL.';
  }

  return contentType === CONTENT_TYPE.content
    ? 'Please enter a valid URL in format: example.com/your-article'
    : 'Please enter a valid URL in format: example.com/your-product';
};

export function validateUrl(url, options = {}) {
  const { contentType, projectType } = options;

  const messages = [];
  const events = [];

  if (isEmpty(url, { ignore_whitespace: true })) {
    messages.push(emptyUrlMessage(projectType, contentType));
    events.push({ type: 'no_input' });
  } else if (!isURL(trim(url))) {
    messages.push(invalidUrlMessage(projectType, contentType));
    events.push({ type: 'invalid_format' });
  }

  const valid = messages.length === 0;

  return { valid, messages, events };
}

export const validateByRules = (validationObj) => {
  const errors = {};
  let isValid = true;

  Object.entries(validationObj).forEach(([fieldName, { rules, value }]) => {
    const error = validate(rules, value);
    errors[fieldName] = error;

    if (isValid && error) {
      isValid = false;
    }
  });

  return {
    isValid,
    errors,
  };
};

export const MAX_CHARS_ERRORS = {
  EMPTY: 'The max characters value is empty',
  NAN: 'Please enter a valid number',
  OVERFLOW: 'Please enter a number less than 10000',
};

export const MAX_CHARS_MAX_VALUE = 10000;
